<template> 
  <v-card class="bank-trial-card">
    <v-card-title>
      Bancos
    </v-card-title>
    <v-card-text>
      <div class="centered-content">
        <img src="/bank_new_icon.png"/>
        <div class="primary--text font-30 pb-7">
          Bancos
        </div>
        <div class="font-weight-light pb-3">
          Comienza la experiencia de automatizar<br>
          tu gestión bancaria con nosotros. <a href="https://www.youtube.com/watch?v=zqJJhWV5PR4" target="_blank">(DEMO)</a>
        </div>
        <template v-if="permission.is_owner">
          <div class="font-weight-bold">Prueba Gratuita*</div>
          <div class="pb-7 flex flex-col">
            <small>*La prueba gratuita incluye la contabilización de 100 transacciones en un máximo de 7 días.</small>
          </div>
          <v-btn            
            rounded
            color="primary"
            :loading="loading_activate_trial"
            @click="activateBankTrial"
            >
            Empieza gratis
          </v-btn>
        </template>
        <div v-else class="font-weight-bold text-center">
          Funcionalidad no activada. Consúltalo con tu asesor
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { ActivateBankTrialCommand } from "@/modules/bank/application/ActivateBankTrialCommand";
import { sync_command_dispatcher } from "@/api/client";
import { mapGetters } from "vuex";


export default {
  name: 'BankTrial',
  components: {    
  },
  props: {      
  },
  data () {
    return {
      loading_activate_trial: false
    }
  },
  methods: {
    async activateBankTrial(){      
      try {
        await new ActivateBankTrialCommand(sync_command_dispatcher, this).run();
        window.location.reload();
      } catch (error) {
        console.error('Error ActivateBankTrial', error)
      }      
    },
  },
  computed: {
    ...mapGetters({        
        permission: 'permissions/permission',
    }),  
  }
}
</script>

<style scoped>
.font-30 {
  font-size: 30px;
}
.bank-trial-card {
  height: 99%;
  min-height: 480px;
  border-radius: 12px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.bank-trial-card .v-card__title {
  color: var(--v-primary-base);
  font-size: 20px;
  font-weight: 500;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 30px;
}

.bank-trial-card .centered-content {
  text-align: center;
  width: 98%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>